import { getTaskTypeCapabilities } from '../../../../taskTypes/generated/taskTypeCapabilities';

/**
 * Domain-split options for a task type, read from the generated capability
 * catalog.
 *
 * These used to be three inline arrays and two `if`-ladders inside
 * `TaskTypeEditor.tsx`: per-type knowledge living in an admin component,
 * invisible to every parity check, and undocumented in the scaffolding
 * skill — so adding a domain-split task type meant editing the admin page.
 *
 * The catalog is authoritative for the OPTIONS. The server does not yet
 * validate `domainId` against them on upload/adjust; that is a separately
 * decided follow-up, deliberately out of M86's scope.
 */
export interface DomainOption {
  domainId: string;
  label: string;
}

/** Ordered options, or null when this type is not domain-split. */
export function domainOptionsFor(taskTypeId: string): DomainOption[] | null {
  const domains = getTaskTypeCapabilities(taskTypeId)?.domains;
  if (!domains) return null;
  return domains.options.map((option) => ({ domainId: option.id, label: option.label }));
}

export function supportsDomainSplit(taskTypeId: string): boolean {
  return getTaskTypeCapabilities(taskTypeId)?.domains != null;
}

/**
 * Types whose tasks must always be created inside a domain — the backend
 * rejects a positive target count without a `domainId`.
 */
export function requiresDomainSplit(taskTypeId: string): boolean {
  return getTaskTypeCapabilities(taskTypeId)?.domains?.required === true;
}
